import { render, staticRenderFns } from "./tradeOrderReconciliation.vue?vue&type=template&id=130e148f&scoped=true"
import script from "./tradeOrderReconciliation.vue?vue&type=script&lang=js"
export * from "./tradeOrderReconciliation.vue?vue&type=script&lang=js"
import style0 from "./tradeOrderReconciliation.vue?vue&type=style&index=0&id=130e148f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e148f",
  null
  
)

export default component.exports